export enum Theme {
  DEFAULT = 'InterTicket design',
  ORANGE = 'Jegy.hu design depricated',
  INTERTICKET_PL = 'Polish design',
  AARHUSBRYGHUS = 'AARHUSBRYGHUS',
  OPLEVBRONDBY = 'OPLEVBRONDBY',
  TEATR_MALY = 'TEATR_MALY',
  MFA = 'MFA',
  EVAALEXIS = 'EVAALEXIS',
  BEGHUSET = 'BEGHUSET'
}
